var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTehnoWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 39,
    viewBox: "0 0 193 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4294 38.1561H21.9505V11.1301H31.9582V1.56386H0.421875V11.1301H10.4294V38.1561ZM48.4587 28.8512V24.042H62.9087V15.1552H48.4587V10.8687H64.9102V1.56386H37.1329V38.1561H65.5449V28.8512H48.4587ZM94.3473 1.56386V14.528H83.7051V1.56386H72.1841V38.1561H83.7051V24.6691H94.3473V38.1561H105.868V1.56386H94.3473ZM136.087 1.56386V18.1871L123.101 1.56386H113.63V38.1561H124.858V21.5327L137.844 38.1561H147.315V1.56386H136.087ZM172.993 38.9925C184.123 38.9925 192.276 30.9421 192.276 19.86C192.276 8.77782 184.123 0.727417 172.993 0.727417C161.862 0.727417 153.71 8.77782 153.71 19.86C153.71 30.9421 161.862 38.9925 172.993 38.9925ZM172.993 29.008C168.746 29.008 165.328 25.5579 165.328 19.86C165.328 14.1621 168.746 10.7119 172.993 10.7119C177.24 10.7119 180.657 14.1621 180.657 19.86C180.657 25.5579 177.24 29.008 172.993 29.008Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTehnoWhiteLogo);
export default __webpack_public_path__ + "static/media/tehnoWhiteLogo.1d8f7c2d32c21eb836d1de2a92be2eda.svg";
export { ForwardRef as ReactComponent };